// removed by extract-text-webpack-plugin
module.exports = {"modalTitle":"_2Yd-2qH5_dmA5L5MobOxti","component":"mx_FbN6dnaeB1bTDvXRGQ","field":"_2knEHnAabLrbbYtr854Qvz","error":"_2nI8E6xtKDxBue47QbD9yG","zhuan_a":"RHb-tCvJvShVw000Ndr6h","zhuan":"rO_QjOKwddDwwKZGHQsZ4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddressInfoModal/AddressInfoModal.scss
 ** module id = 944
 ** module chunks = 0
 **/